import { gql } from '@common/bff';

export const UNDO_TRIP = gql`
  mutation TripModule_UndoTrip($tripId: String!) {
    undoTrip(tripId: $tripId)
  }
`;
